import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-app-polyfill/ie11';
import React from 'react'
import ReactDOM from 'react-dom'
import LocationsMap from './LocationsMap';

const map = document.getElementById('locations-map');

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <LocationsMap/>,
    map
  )
})